module.exports = __webpack_public_path__ + "img/103.ad137b13.jpg";